import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const SquareArrowRightContainer = styled.div<{ offset: number }>`
  background: rgba(0, 0, 0, 0.8);
  border-radius: ${Screen.widthRatio * 20}px 0 0 ${Screen.widthRatio * 20}px;
  height: ${Screen.widthRatio * 110}px;
  left: ${(props) => Screen.widthRatio * props.offset}px;
  line-height: ${Screen.widthRatio * 150}px;
  opacity: 0;
  padding-left: ${Screen.widthRatio * 19}px;
  position: absolute;
  top: ${112 * Screen.widthRatio}px;
  width: ${Screen.widthRatio * 49}px;
  &:hover {
    opacity: 1;
  }
  & > svg {
    position: absolute;
    top: ${Screen.widthRatio * 40}px;
  }
`;

export default withAnimation(SquareArrowRightContainer);
